import { render, staticRenderFns } from "./MenuSubItem.vue?vue&type=template&id=14ce9908&scoped=true&"
import script from "./MenuSubItem.vue?vue&type=script&lang=js&"
export * from "./MenuSubItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuSubItem.vue?vue&type=style&index=0&id=14ce9908&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ce9908",
  null
  
)

export default component.exports